export default __webpack_public_path__ + "images/dec4818a3d9b37cfa9b62eed8a3f2375.png";